module.exports = __webpack_public_path__ + "static/media/indiaMap.ed6d4e39.png";